import { ContentChild, Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: 'paginator-page'
})
export class PaginatorPageComponent {
    @ContentChild(TemplateRef)
    template!: TemplateRef<any>;
}